<px-t40-mediacenter
    [tiles]="tiles"
    [filterGroups]="filterGroups"
    [contactFooter]="_contactFooter"
    [hasMore]="totalFileCount > files?.length"
    (loadMore)="loadMore()"
    (selectedFilters)="onFilterChanged($event)"
></px-t40-mediacenter>
